export default "__VITE_ASSET__VSbhPNko__"